import { observer } from 'mobx-react';
import { useState } from 'react';
import { QuoteStep, SelectEntityOption } from '../../utils/constants';
import { useThirdPartyLoanStore } from '../../hooks/useThirdPartyLoanStore';
import { AddEntityCard } from '../common/addEntityCard';
import { SearchExistingEntity } from './searchExistingEntity';
import { SelectEntityOptionCard } from './selectEntityOptionCard';
import { useQuoteTypeStore } from '../../hooks/useQuoteTypeStore';

export const EntityInformationStep = observer(() => {
  const { quoteTypeStore } = useQuoteTypeStore();
  const { entityStore, borrowersStore } = quoteTypeStore;
  const option = entityStore.selectEntityOption;

  const setOption = option => {
    entityStore.setSelectEntityOption(option);
    if (option === SelectEntityOption.NO_ENTITY) {
      quoteTypeStore.goToStep(QuoteStep.BORROWER_INFORMATION);
    }
  };

  return (
    <>
      {(!option || option === SelectEntityOption.NO_ENTITY) && (
        <SelectEntityOptionCard option={option} onSelect={setOption} />
      )}
      {option === SelectEntityOption.SEARCH_ENTITY && <SearchExistingEntity />}
      {option === SelectEntityOption.ADD_ENTITY && <AddEntityCard />}
    </>
  );
});
